"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Phone, ArrowRight, ShieldCheck, Clock, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function EmergencyHelp() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 16
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.35,
        ease: "easeOut"
      }
    }
  };
  return <section id="have-this-problem" data-nav="light" className="relative bg-background py-14 md:py-20 lg:py-24">
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8 lg:px-10">
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.3
      }} className="relative overflow-hidden rounded-2xl border border-border bg-card p-8 md:p-12 lg:p-16 shadow-lg">
          {/* Subtle brand motif accent bar on left */}
          <div className="absolute top-0 left-0 h-full w-2 bg-accent" />

          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-center">
            {/* Left Content Area */}
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 rounded-full border border-border bg-secondary px-3.5 py-1 text-xs font-bold tracking-wide uppercase text-secondary-foreground mb-4">
                <span className="inline-block size-2 rounded-full bg-accent animate-pulse" />
                <span>{"24/7 Rapid Emergency Response"}</span>
              </div>

              <h2 className="font-default text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-card-foreground">
                {"Have a Plumbing Problem?"}
              </h2>

              <p className="mt-4 text-base sm:text-lg text-muted-foreground leading-relaxed max-w-2xl">
                {"Tell us what's happening and find the right plumbing service for your situation."}
              </p>

              {/* Guarantees list */}
              <div className="mt-6 flex flex-wrap gap-y-2 gap-x-6 text-sm font-medium text-card-foreground">
                <div className="flex items-center gap-2">
                  <ShieldCheck className="size-4 text-primary" />
                  <span>{"Licensed & Insured Local Plumbers"}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Clock className="size-4 text-primary" />
                  <span>{"Average Arrival: Under 45 Mins"}</span>
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="size-4 text-primary" />
                  <span>{"Clear, Upfront Pricing"}</span>
                </div>
              </div>
            </div>

            {/* Right Action Cluster */}
            <div className="lg:col-span-5 flex flex-col sm:flex-row lg:flex-col gap-4 justify-center items-stretch lg:items-end">
              <Button asChild className="w-full sm:w-auto lg:w-full h-auto py-4 px-8 rounded-full bg-primary text-primary-foreground font-bold text-base sm:text-lg shadow-md hover:bg-primary/90 active:scale-[0.98] transition-[background-color,transform,box-shadow]">
                <a href="tel:4708479076" className="inline-flex items-center justify-center gap-3">
                  <Phone className="size-5 fill-current" />
                  <span>{"Call (470) 847-9076"}</span>
                </a>
              </Button>

              <Button asChild className="w-full sm:w-auto lg:w-full h-auto py-3.5 px-8 rounded-full bg-accent text-accent-foreground font-semibold text-base shadow hover:brightness-105 active:scale-[0.98] transition-[filter,transform,box-shadow]">
                <Link to="/contact/" className="inline-flex items-center justify-center gap-2">
                  <span>{"Request Service"}</span>
                  <ArrowRight className="size-4" />
                </Link>
              </Button>

              <p className="text-xs text-center lg:text-right text-muted-foreground mt-1">
                {"Immediate dispatch available across Jonesboro, GA and surrounding areas."}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}